<div class="form-page-wrapper">
  @if (!loading()) {
    <div class="registrant-card">
      <h2 class="registrant-card-title">Registration Form</h2>
      <div class="registrant-card-details">
        <div class="details-header">
          <span>
            <p>Details</p>
            <mat-icon class="tooltip-icon" [matTooltip]="tooltips.details">info</mat-icon>
          </span>
          <div class="header-button-wrapper">
            <button class="button-copy-link" [disabled]="!isFormLive" (click)="copyRegistrationLink()">
              Copy Registration Link
            </button>
            <button
              class="button-copy-link mt-2"
              [matTooltip]="tooltips.embed"
              [disabled]="!isFormLive"
              (click)="copyEmbedCode()"
            >
              Copy Embed Code
            </button>
          </div>
        </div>
        <div class="details-content">
          <span class="content-title">Event Name</span>
          <span class="content-value">{{ event().name }}</span>
        </div>
        <div class="details-content">
          <span class="content-title">Event Description</span>
          <span class="content-value" style="font-size: 12px">
            <div [title]="event().description" [innerHTML]="safeEventDescription()"></div>
          </span>
        </div>
      </div>
      <div class="registrant-card-details">
        <p>
          Email, First Name, and Last Name are required fields by default, all other questions are derived from your
          Scootaverse's Smart Badge questions. You can add more fields to the registration form by
          <a [routerLink]="smartBadgeLink()">adding new Smart Badge questions</a>.
        </p>
        <div class="details-header">
          <span>
            <p>Registration Fields</p>
            <mat-icon class="tooltip-icon" [matTooltip]="tooltips.registration"> info </mat-icon>
          </span>
          <span class="required-label">Required</span>
        </div>
        <div cdkDropList class="registration-form-fields" (cdkDropListDropped)="drop($event)">
          @for (field of registrationFields(); track field; let i = $index) {
            <div class="registration-field" cdkDrag>
              <div class="registration-field-title">
                <mat-icon> drag_indicator </mat-icon>
                <span>
                  {{ field.name }}
                </span>
              </div>
              <div class="registration-field-options">
                <mat-checkbox
                  [(ngModel)]="field.required"
                  [matTooltip]="!!field.disabled ? 'This field is required by default' : ''"
                  [ngClass]="{ 'checkbox-margin': field.disabled }"
                  [disabled]="!!field.disabled"
                  (ngModelChange)="changeField()"
                ></mat-checkbox>
                @if (!field.disabled) {
                  <button type="button" class="button-icon" (click)="removeField(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>
        <button class="button-secondary button-max-width" (click)="openOptionsDialog()">Add Fields</button>
      </div>
    </div>
    <div class="preview-card">
      <div class="form-status justify-between">
        <div class="flex items-center">
          <p>Form Status</p>
          <mat-icon class="tooltip-icon" [matTooltip]="tooltips.status"> info </mat-icon>
        </div>
        @if (formStatus()) {
          <div
            class="form-status-chip"
            [ngStyle]="{ background: formStatus()!.background, color: formStatus()!.color }"
          >
            {{ formStatus()!.title }}
          </div>
        }
        <button [ngClass]="buttonProperty().class" (click)="changeRegistrationStatus()">
          {{ buttonProperty().text }}
        </button>
      </div>
      <div class="registration-form-preview">
        <div class="header-preview">
          <p>Registration Form Preview</p>
          <mat-icon class="tooltip-icon" [matTooltip]="tooltips.preview"> info </mat-icon>
        </div>
        <div class="registration-form">
          <div class="preview-mode"></div>
          <app-registration-form
            class="w-full flex justify-center"
            [event]="event()"
            [registrationFields]="registrationFields()"
            [isPreview]="true"
          />
        </div>
      </div>
    </div>
  } @else {
    <app-loading class="registration-loading-container" />
  }
</div>
